import * as utilities from "../src/utilities";
import * as digitalDataFormatters from "../src/digitalDataFormatters";

const _psCommon = {   
    'currentNow': () => {

        let now = (function() {
            let today = new Date(),
                utcyyyy = today.getUTCFullYear(),
                utcmm = today.getUTCMonth() + 1,
                utcdd = today.getUTCDate(),
                utctoday = '';
    
            if (utcdd < 10) {
                utcdd = '0' + utcdd;
            }
            if (utcmm < 10) {
                utcmm = '0' + utcmm;
            }
    
            utctoday = utcyyyy + '-' + utcmm + '-' + utcdd;
    
            return utctoday;
        }());
    
        return now;
    
    },
    'formatRecommendation': ( recObj, prop37 = "" ) => {

        recObj = (typeof recObj !== 'undefined' ? recObj : {});
    
        const _clean = ( str) => {
    
            if ( typeof str === "string" ) {
                str = str.replace( /:/g, "-" );
            }
    
            return str;
        }
    
        let result = [];
    
        result.push(recObj.recommendationType ? _clean( recObj.recommendationType ) : 'n/a');
        result.push(recObj.pageType ? _clean( recObj.pageType ) : 'n/a');
        result.push(recObj.displayPosition ? _clean( recObj.displayPosition ) : 'n/a');
        result.push(recObj.anchorProductSku ? _clean( recObj.anchorProductSku ) : 'n/a');
        result.push(prop37 ? prop37 : 'n/a');
        result.push(recObj.strategy ? _clean( recObj.strategy ) : 'n/a');
        result.push(recObj.recommendationVersion ? _clean( recObj.recommendationVersion ) : 'n/a');
        result.push(recObj.featureVersion ? _clean( recObj.featureVersion ) : 'n/a');
        result.push(recObj.interval ? _clean( recObj.interval ) : 'n/a');
        result.push(recObj.sponsoredProduct ? _clean( recObj.sponsoredProduct ) : 'n/a');
    
        result = result.join(":");
    
        return ( result.toLowerCase() !== "n/a:n/a:n/a:n/a:n/a:n/a:n/a:n/a:n/a:n/a" ? result : "" );
    },     
    'getAttachedLabor': ( itemArray ) => {

        itemArray = ( Array.isArray(itemArray) ? itemArray : [] );
    
        let result = {
                "installFound": false,
                "installAnchorSku": "",
                "proreferralFound": false,
                "proreferralAnchorSku": "",
                "sellableAssemblyFound": false,
                "sellableAssemblyAnchorSku": []
            },
            obj = {},
            i;
    
        for ( i = 0; i < itemArray.length; i++ ) {
    
            obj = itemArray[i];
    
            if ( obj.productInfo ) {
    
                if ( obj.productInfo.installationDisplayed || obj.productInfo.laborType === "installation" ) {
    
                    result.installFound = true;
                    result.installAnchorSku = ( obj.productInfo.anchorSku ? obj.productInfo.anchorSku : "" );
    
                }
    
                if ( obj.productInfo.proReferralDisplayed || obj.productInfo.laborType === "proreferral" ) {
    
                    result.proreferralFound = true;
    
                    if ( obj.productInfo.anchorSku ) {
                        result.proreferralAnchorSku = obj.productInfo.anchorSku;
                    } else {
                        result.proreferralAnchorSku = ( obj.productInfo.sku ? obj.productInfo.sku : "" );
                    }
    
                }
    
                if ( obj.productInfo.laborType === "sellable assembly" ) {
                    result.sellableAssemblyFound = true;
    
                    if ( obj.productInfo.anchorSku ) {
                        result.sellableAssemblyAnchorSku.push( obj.productInfo.anchorSku );
                    }
                }
            }
    
        }
    
        return result;
    
    },
    'getBackOrder': ( prodInfo = {}, fulfillment = {} ) => {
    
        let backOrder = ( prodInfo && prodInfo.availabilityStatus && prodInfo.availabilityStatus.backOrder ? prodInfo.availabilityStatus.backOrder.toString().toLowerCase() : '' );        
        backOrder = ( !backOrder && fulfillment && fulfillment.backOrder ? fulfillment.backOrder.toString().toLowerCase(): backOrder );

        return backOrder;

    },
    'getETADiff': ( etaObj ) => {

        let now = _psCommon.currentNow();
    
        etaObj = ( typeof( etaObj ) === "object" ? etaObj : {} );
    
        if ( !utilities.objHasValue( etaObj ) ) {
            return "";
        }
    
        function daysInMonth( month, year ) {
            return new Date( year, month, 0 ).getDate();
        }
    
        let myList = ["sth", "boss", "appl", "bodfs"],
            etaArray = [],
            results = "",
            eta = "",
            i;
    
        for ( i = 0; i < myList.length; i++ ) {
    
            let etaStart = _psCommon.isValidDate(etaObj[myList[i] + 'StartDate']) ? etaObj[myList[i] + 'StartDate'] : '',
                etaEnd = _psCommon.isValidDate(etaObj[myList[i] + 'EndDate']) ? etaObj[myList[i] + 'EndDate'] : '',
    
                startDay = etaStart ? parseInt(etaStart.split('-')[2]) : 'n/a',
                endDay = etaEnd ? parseInt(etaEnd.split('-')[2]) : 'n/a',
                startMonth = etaStart ? parseInt(etaStart.split('-')[1]) : '',
                endMonth = etaEnd ? parseInt(etaEnd.split('-')[1]) : '',
                currentDay = parseInt(now.split('-')[2]),
                currentMonth = parseInt(now.split('-')[1]),
                currentDaysInMonth = daysInMonth(parseInt(now.split('-')[1]), parseInt(now.split('-')[0]));
    
            if (etaStart !== "" || etaEnd !== "") {
    
                if (endDay === "n/a") {
    
                    if (startMonth !== currentMonth) {
                        eta = myList[i] + ":" + ((startDay + currentDaysInMonth) - currentDay) + "-NA days";
                        etaArray.push(eta);
                    } else {
                        eta = myList[i] + ":" + (startDay - currentDay) + "-NA days";
                        etaArray.push(eta);
                    }
                } else if (startDay === "n/a") {
    
                    if (endMonth !== currentMonth) {
                        eta = myList[i] + ":NA-" + ((endDay + currentDaysInMonth) - currentDay) + " days";
                        etaArray.push(eta);
                    } else {
                        eta = myList[i] + ":NA-" + (endDay - currentDay) + " days";
                        etaArray.push(eta);
                    }
                } else if (etaStart === etaEnd) {
    
                    if (startMonth !== currentMonth) {
                        eta = myList[i] + ":" + ((startDay + currentDaysInMonth) - currentDay) + " days";
                        etaArray.push(eta);
                    } else {
                        eta = myList[i] + ":" + (startDay - currentDay) + " days";
                        etaArray.push(eta);
                    }
                } else if (etaStart !== etaEnd) {
    
                    if (startMonth !== currentMonth && endMonth !== currentMonth) {
                        eta = myList[i] + ":" + ((startDay + currentDaysInMonth) - currentDay) + "-" + ((endDay + currentDaysInMonth) - currentDay) + " days";
                        etaArray.push(eta);
                    } else if (startMonth !== currentMonth) {
                        eta = myList[i] + ":" + ((startDay + currentDaysInMonth) - currentDay) + "-" + (endDay - currentDay) + " days";
                        etaArray.push(eta);
                    } else if (endMonth !== currentMonth) {
                        eta = myList[i] + ":" + (startDay - currentDay) + "-" + ((endDay + currentDaysInMonth) - currentDay) + " days";
                        etaArray.push(eta);
                    } else {
                        eta = myList[i] + ":" + (startDay - currentDay) + "-" + (endDay - currentDay) + " days";
                        etaArray.push(eta);
                    }
                }
    
    
                if (etaArray.length > 1) {
    
                    results = etaArray.join(">");                
                } else {
                    results = etaArray[0];
                }    
            }        
        }
        return results;    
    },
    'getETAObj':  ( items, sku ) => {
        let etaObj = items.filter( (eta) => {
            var etaSku = (eta.sku ? eta.sku : '');
    
            return etaSku === sku;
        });
    
        return (etaObj.length && etaObj[0].eta ? etaObj[0] : {});
    },
    /**
     * Uses ddo.product.productInfo.eta to populate evar112
     * @param:(Object) etaObj - ddo object
     * @returns: (string) - "sth-start:2018-01-25,sth-end:2018-01-27"
     */
    'getETAString': ( etaObj ) => {

        etaObj = (typeof etaObj === "object" ? etaObj : {});

        if (!utilities.objHasValue(etaObj)) {
            return "";
        }

        let myList = ["sth", "boss", "appl", "bodfs"],
            etaArray = [],
            results = "",
            eta = "",
            i;

        for (i = 0; i < myList.length; i++) {

            let etaStart = _psCommon.isValidDate(etaObj[myList[i] + 'StartDate']) ? etaObj[myList[i] + 'StartDate'] : '',
                etaEnd = _psCommon.isValidDate(etaObj[myList[i] + 'EndDate']) ? etaObj[myList[i] + 'EndDate'] : '';

            if (etaStart) {

                eta = myList[i] + "-start:" + etaStart;

                etaArray.push(eta);
            }

            if (etaEnd) {

                eta = myList[i] + "-end:" + etaEnd;

                etaArray.push(eta);

            }

            if (etaArray.length > 0) {
                results += etaArray.join("_") + ">";
                etaArray = [];
            }
        }

        return results;

    },
    'getObjFromPath': ( path ) => {

        let obj = {};
        let paths = path.split( '.' );
        
        paths.reduce( function( obj, path ) {
          return obj[path] = {}
        }, obj );
    
        return obj;
        
    },
    'getRecObjFromItemArray': ( items, sku ) => {
        let recObj = items.filter( ( rec ) => {
            let recSku = rec.productInfo && rec.productInfo.sku ? rec.productInfo.sku : '';
    
            // Grab the display position from the item array and inject it into the recommendaiton object
            if ( rec.recommendation ) {

                rec.recommendation.displayPosition = ( rec.displayPosition ? rec.displayPosition : rec.recommendation.displayPosition ? rec.recommendation.displayPosition : '' );

            }
    
            return recSku.toString() === sku.toString();
        });
    
        return ( recObj.length && recObj[0].recommendation ? recObj[0].recommendation : {} );
    },
    'getRecommendation': ( ddorec, stashrec ) => {
        return ( utilities.objHasValue( stashrec ) ? stashrec : ddorec );
    },
    'getStashRecommendation': ( stashRecObj, sku, ddoRecommendation = {} ) => {
        let result = {};

        // handle case when REC OBJ is an Array
        if ( Array.isArray( stashRecObj ) ) { 
            result = _psCommon.getRecObjFromItemArray( stashRecObj, sku );
        } else {
            result = ( utilities.objHasValue( ddoRecommendation ) ? ddoRecommendation : stashRecObj );
        }
        return result;
    },
    'getSKUFromProdInfo': ( prodInfo, defaultSKU = '' ) => {
        
        let sku = ( prodInfo.sku ? prodInfo.sku : defaultSKU );

        return ( sku && prodInfo.laborType === "proreferral" ? `${sku}-pro` : sku ); 

    }, 
    'isValidDate': ( dateString ) => {

        let regEx = /^\d{4}-\d{2}-\d{2}$/;
    
        if ( typeof( dateString ) !== 'string' ) {
            return false;
        }
    
        if ( !dateString.match( regEx ) ) {
            return false;
        }
    
        let d = new Date( dateString );
    
        if ( !d.getTime() ) {
            return false;
        }
    
        return d.toISOString().slice( 0, 10 ) === dateString;
    },            
    'normalizeFulfillment': ( item ) => {

        //check input
        item = typeof item === 'object' ? item : {};
    
        // normalize item.fulfillment
        let fulfillment = item.fulfillment ? item.fulfillment : {},
            prodInfo = item.productInfo ? item.productInfo : item;
    
        if (typeof(fulfillment.method) === 'undefined') {
            if (item.fulfillmentMethod) {
                fulfillment.method = item.fulfillmentMethod;
            } else if (prodInfo.fulfillmentMethod) {
                fulfillment.method = prodInfo.fulfillmentMethod;
            }
        }
    
    
        if (typeof(fulfillment.store) === 'undefined' && item.fulfillmentStore) {
            fulfillment.store = item.fulfillmentStore;
        } else if (prodInfo.fulfillmentStore) {
            fulfillment.store = prodInfo.fulfillmentStore;
        }
    
        if (typeof(fulfillment.zip) === 'undefined' && item.fulfillmentZip) {
            fulfillment.zip = item.fulfillmentZip;
        } else if (prodInfo.fulfillmentZip) {
            fulfillment.zip = prodInfo.fulfillmentZip;
        }
    
        return fulfillment;
    },
    'normalizePrice': ( item ) => {
        item = typeof item === 'object' ? item : {};
    
        let price = item.price && typeof( item.price ) === 'object' ? item.price : item.price && typeof( item.price ) === 'string' || typeof( item.price ) === 'number' ? {
            "basePrice": item.price
        } : {};
    
        if ( typeof ( price.priceType ) === 'undefined' && item.priceType ) {
            price.priceType = item.priceType;
        }
    
        return price;
    },        
    'normalizeRecommendation': ( item ) => {
        item = typeof item === 'object' ? item : {};
    
        return item.recommendation ? item.recommendation : item.productInfo && item.productInfo.recommendation ? item.productInfo.recommendation : {};
    },
    'setATCLocation': ( result, atcLocation, stashATCLoc, pageType ) => {
        let v53Value = "";
    
        // atcLocation DC object takes precedence;
        if ( atcLocation ) {
            // Can be an object(preferred method we are driving toward) an array (used this way in MW) or a string(used this way in collections).  We need
            // to handle all of these cases until the clean-up happens.

            if ( typeof atcLocation === 'string' ) {
                v53Value = atcLocation;
            } else if ( Array.isArray( atcLocation ) && atcLocation[0] ) {
                v53Value = atcLocation[0];
            } else {
                v53Value = digitalDataFormatters.formatATCLocation( pageType, atcLocation );
            }
    
        } else if ( stashATCLoc ) {
            v53Value = stashATCLoc;
        } else if ( typeof pageType !== 'undefined' ) {
            v53Value = pageType;
        }
    
        utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar53', v53Value );
    },
    'setATCPriceAndQuantity': ( result, item, price ) => {

        // Set product string events
		utilities.setDimension( result, '_experience.analytics.event1to100.event2.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event1to100.event4.value', digitalDataFormatters.stripComma( price.giftCardReloadPrice ?? price.basePrice ) );

        // sku counter [TODO]: Check how to set this merchandising event
        utilities.setDimension( result, '_experience.analytics.event101to200.event192.value', 1);

    },
    'setAttachedLaborMetrics': ( result, attachedLabor, prodInfo, opts = {}  ) => {

        let v131 = "";

        // Consolidated ALL logic for attached labor into this method, broken down by the specific use cases (ps methods).
        // Wanted to see all this logic in one place.
        // the opts{} argument contains unique data attributes needed for each use case (apart from opts.method which is common across all use cases)        
        if ( opts.method === 'cartView' ) {

             // Installation tracking
             if ((attachedLabor.installFound && attachedLabor.installAnchorSku === opts.sku) || prodInfo.installationDisplayed || prodInfo.laborType === "installation") {
                
                v131 = "installation";

            }

            // ProReferral tracking
            if ((attachedLabor.proreferralFound && attachedLabor.proreferralAnchorSku === opts.sku) || prodInfo.proReferralDisplayed) {
                
                v131 = "proreferral";

            }

            // Sellable Assembly tracking
            if ( (prodInfo.laborType === "sellable assembly") || (attachedLabor.sellableAssemblyAnchorSku.indexOf(opts.sku) != -1) ) {
                
                v131 = "sellable assembly";

            }


        } else if ( ['productView','installationSku'].includes( opts.method ) ) {

            // Installation tracking
            if ((attachedLabor.installFound && opts.index == "0") || prodInfo.installationDisplayed || prodInfo.laborType === "installation") {            
                
                v131 = "installation";

            }

            //ProReferral tracking (this was the only difference between productView and installationSku logic)
            if ( opts.method === 'productView' && attachedLabor.proreferralFound ) {            
                
                v131 = "proreferral";            

            }

            // Sellable Assembly tracking
            if ( attachedLabor.sellableAssemblyFound || (prodInfo.laborType === "sellable assembly") ) {                            

                v131 = "sellable assembly";         

            }
        } else if ( opts.method === 'attachedLaborSku' ) {

            // Installation tracking//ProReferral tracking//Sellable Assembly tracking
            if ( attachedLabor.installFound || attachedLabor.proreferralFound || attachedLabor.sellableAssemblyFound ) {

                v131 = opts.laborType; 

            }

            
         } else if ( opts.method === 'proreferralSku' ) {

            //ProReferral tracking
           if ( attachedLabor.proreferralFound ) {

                v131 = "proreferral";  

            }

            
        }


        if ( v131 ) {

            utilities.setDimension( result, '_experience.analytics.event101to200.event193.value', 1 );
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar131', v131 );

        }

        return v131;
        
    },
    'setBackorderMetrics': ( result, prodInfo = {}, fulfillment = {} ) => {
         let backOrder = _psCommon.getBackOrder ( prodInfo, fulfillment );

         if ( backOrder === 'yes' || backOrder === 'true' ) {
            utilities.setDimension( result, '_experience.analytics.event101to200.event125.value', 1 ); 
         }
    },   
    'setBadgeData': ( badgeObj, pageType = '', key = 'type') => {
    
        let pt = (pageType ? pageType + ">" : '');
    
        return badgeObj.map(function(elem) {
            return (elem[key] ? elem[key] : "n/a") + ">" + 
                pt +      
                (elem.recommendationStrategy ? elem.recommendationStrategy : "n/a") + ">" +
                (elem.recommendationVersion ? elem.recommendationVersion : "n/a");
        }).join("~");
    },  
    'setBadgeTypeMetrics': ( result, badgeArray ) => {

        if ( Array.isArray( badgeArray ) && badgeArray.length ) {

            let badges = badgeArray.map(function(elem) {
                if (elem.type && elem.name) {
                    return (elem.type + ">" + elem.name);
                } 
            }).join(":");
                    
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar149', badges );

       }

    },
    'setBundleMetrics': ( result, prodInfo ) => {
         
        if ( typeof ( prodInfo.packageID ) !== 'undefined' && prodInfo.packageID !== '' ) {
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar48', prodInfo.packageID );
        }

        if ( typeof ( prodInfo.bundleType ) !== 'undefined' && prodInfo.bundleType !== '' ) {
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar202', prodInfo.bundleType );
        }

    },    
    'setCartFulfillmentChangeMetrics': ( result, fulfillment ) => {

         
         if ( fulfillment.previousMethod ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar121', `${fulfillment.previousMethod}>${(fulfillment.method ? fulfillment.method : "")}` );
        }


    },
    'setCheckFulfillmentAvailabilityMetrics': ( result, fulfillment, pageType, stashCheckAvailValue ) => {

        let v7 = stashCheckAvailValue ?? `${(fulfillment.method ? fulfillment.method : '')}>${pageType}${(fulfillment.zip ? ">" + fulfillment.zip : '')}`;

        if ( v7 ) utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar7', v7 );
    
    },  
    'setDiscountMetrics': ( result, price ) => {

            if ( price.discountCode ) {

                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar20', price.discountCode );

            }  

            if ( price.discountAmount ) {                
                utilities.setDimension( result, '_experience.analytics.event1to100.event57.value', digitalDataFormatters.stripComma( price.discountAmount ) );
            }

    },
    'setETAMetrics': ( result, prodInfo ) => {
         
         if ( utilities.objHasValue( prodInfo.eta ) ) {

            let v112 = _psCommon.getETAString( prodInfo.eta );
            let v165 = _psCommon.getETADiff( prodInfo.eta );

            if ( v112 ) {                
                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar112', v112 );
            }

            if ( v165 ) {                
                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar165', v165 );
            }
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar166', _psCommon.currentNow() );

        }

    },    
    'setFulfillmentMethodMetrics': ( result, fulfillment ) => { 
        const METHOD_MAP = {
            'shiptohome': 'sth',
            'shiptostore': 'boss',
            'deliverfromstore': 'bodfs'
        };

        // Fulfillment Method
        if ( fulfillment.method ) {
            
            let method = METHOD_MAP[ fulfillment.method.toLowerCase() ] || fulfillment.method;

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar36', method );
        }

    }, 
    'setFulfillmentStoreMetrics': ( result, fulfillment ) => {

        if ( fulfillment.store ) {      

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar52', fulfillment.store );

        }

    },
    'setIDMMetrics': ( result, prodInfo ) => {

        let idmArr = [],
            _v187 = "",
            keys = ['department','class','subclass','manufacturer'];

        keys.forEach( key => {                        
            idmArr.push( ( typeof ( prodInfo[key]) === 'string' && prodInfo[key] !== "" ? prodInfo[key].toString().padStart( 3, '0' ) : 'na') );
        }); 

        _v187 = idmArr.join("-");

        if ( _v187 && _v187 !== "na-na-na-na" ) {    
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar187', _v187 );

        }


    },
    'setInstoreAssemblyMetrics': ( result, prodInfo = {} ) => {

        if ( prodInfo.assembly && prodInfo.assembly.toString().toLowerCase() === 'in store' ) {
            
            utilities.setDimension( result, '_experience.analytics.event201to300.event271.value', 1 );

        }

    },
    'setListLocationMetrics': ( result, item ) => {

        if ( item.listLocation ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar81', item.listLocation );
            
        }

    },    
    'setMapPricingMetrics': ( result, prodInfo ) => {

        if ( prodInfo.mapPrice ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar209', prodInfo.mapPrice );

        }

    },
    'setOOSMetrics': ( result, shippingStatus, storeStatus ) => {

        //STH OOS
        if ( shippingStatus && shippingStatus.sth ) {

            if ( shippingStatus.sth === 'oos' ) {
                
                utilities.setDimension( result, '_experience.analytics.event1to100.event56.value', 1 );

            } else if ( shippingStatus.sth === 'available' ) {

                utilities.setDimension( result, '_experience.analytics.event201to300.event204.value', 1 );
            }

        }

        //BOPIS OOS
        if ( storeStatus && storeStatus.bopis ) {

            if ( storeStatus.bopis === 'oos' ) {
                
                utilities.setDimension( result, '_experience.analytics.event101to200.event195.value', 1 );

            } else if ( storeStatus.bopis === 'available' ) {
                
                utilities.setDimension( result, '_experience.analytics.event201to300.event205.value', 1 );

            }

        }

        //BODFS
        if ( shippingStatus && shippingStatus.bodfs ) {

            if ( shippingStatus.bodfs === 'displayed' ) {
        
                utilities.setDimension( result, '_experience.analytics.event201to300.event206.value', 1 );

            }

        }

        //BOSS
        if ( storeStatus && storeStatus.boss ) {

            if ( storeStatus.boss === 'oos' ) {
                
                utilities.setDimension( result, '_experience.analytics.event101to200.event198.value', 1 );

            } else if ( storeStatus.boss === 'available' ) {
                
                utilities.setDimension( result, '_experience.analytics.event201to300.event207.value', 1 );

            }

        }

    },
    'setPodClickMetrics': ( result, podClick, defaultText = 'n/a' ) => {
            
        if ( podClick ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar160', digitalDataFormatters.formatPodClick( podClick, defaultText ) );

        }
    },
    'setProductAvailabilityTypeMetrics': ( result, prodInfo = {} ) => {

        if ( prodInfo.availabilityStatus && prodInfo.availabilityStatus.type ) {   

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar133', `${prodInfo.availabilityStatus.type}>online-${(prodInfo.availabilityStatus.shipping && prodInfo.availabilityStatus.shipping.skuStatus ? prodInfo.availabilityStatus.shipping.skuStatus : "")}:store-${(prodInfo.availabilityStatus.store && prodInfo.availabilityStatus.store.skuStatus ? prodInfo.availabilityStatus.store.skuStatus : "")}` );

        }
    },  
    'setQuoteMetrics': ( result, quoteID, quoteType, quoteLocation ) => {

        if ( quoteID ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar190', quoteID );

        }

        if ( quoteType ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar191', quoteType );

        }

        if ( quoteLocation ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar192', quoteLocation );

        }

    },      
    'setRecommendationMetrics': ( result, recommendation, prop37 = "" ) => {

        let recValue = _psCommon.formatRecommendation( recommendation, prop37 ),
            _setV104 = ( recstring ) => {

            recstring = ( typeof (recstring) === "string" ? recstring : "" );
        
            let parts = recstring.split( ":" );
        
            return  ( parts.length > 1 ? parts[0] + ":" + parts[1] : "" );
        
        };
                    
        if ( recValue ) {

            if ( recommendation.recommendationType?.startsWith( "rv" )) {
                
                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar64', recValue );

            } else if (recommendation.recommendationType?.startsWith( "sp" )) {
                
                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar67', recValue );

            } else {

                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar102', recValue );

            }

            
            // Product Recommendation
            let v104 = _setV104( recValue );

            if ( v104 ) {

                utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar104', v104 );

            }        

           

        }
    },
    'setServiceLevelMetrics': ( result, prodInfo ) => {

        if ( prodInfo.serviceLevel ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar189', prodInfo.serviceLevel );

        }

    },
    'setShipFromFastestLocationMetrics': ( result, prodInfo ) => {

        if ( typeof ( prodInfo.shipFromFastestLocation ) !== 'undefined' && prodInfo.shipFromFastestLocation === true ) {
            
            utilities.setDimension( result, '_experience.analytics.event301to400.event308.value', 1 );
        
        }

    },
    'setSolverPathMetrics': ( result, solverPath, sku = '' ) => {
        
        if ( solverPath ) {

            // Cart Add Case needs this extra logic.  
            if ( Array.isArray( solverPath ) ) {
                let solverPathIndex = solverPath.findIndex(product => product.productID === sku);
                if ( solverPathIndex !== -1 ) {
                    if ( solverPath[solverPathIndex].solverPath ) {
                        solverPath = solverPath[solverPathIndex].solverPath;
                    }
                }
            } 

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar122', solverPath );
        }

    },
    'setStoreTypeMetrics': ( result, prodInfo ) => {

        if ( prodInfo.storeType ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar134', prodInfo.storeType );

        }
    },
    'setSubscriptionMetrics': ( result, item ) => {
        
        if ( item.subscription && item.subscription.frequency ) {
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar115', item.subscription.frequency );   
        }

    }


};

const _psMethods = {

    'attachedLaborSku': ( item, options ) => {

        let result = {},
            anchorSku = ( function ( attachedLabor ) {
                    let result = "";
                    if ( attachedLabor.installAnchorSku ) {
                        result = attachedLabor.installAnchorSku;
                    }
                    else if ( attachedLabor.proreferralAnchorSku ) {
                        result = attachedLabor.proreferralAnchorSku + "-pro";
                    }
                    else if ( attachedLabor.sellableAssemblyAnchorSku.length > 0 ) {
                        result = attachedLabor.sellableAssemblyAnchorSku[ 0 ];
                    }
                    return result;
                }( options.attachedLabor ) ),        
            nextItem = {}, 
            v131 = "";

        // Attached Labor (Installation/ProReferral/Sellable Assembly) Tracking: eVar131, event193    
        v131 = _psCommon.setAttachedLaborMetrics( result, options.attachedLabor, options.prodInfo, { "method":"attachedLaborSku", "laborType": options.laborType } );
        
        //set anchor SKU and associated metrics as a new item on the product string
        if ( v131 ) {

            nextItem.SKU = String( anchorSku );
            
            utilities.setDimension( nextItem, '_experience.analytics.event101to200.event193.value', 1 );
            utilities.setDimension( nextItem, '_experience.analytics.customDimensions.eVars.eVar131', v131 );
            
            options.productListItems[options.currentIndex + 1] = nextItem;   

        }

        return result;
                
    },
    'bssOverlay': ( item, options ) => {
        
        let result = {};

        // Check Fulfillment Availability: eVar7
        _psCommon.setCheckFulfillmentAvailabilityMetrics( result, options.fulfillment, options.pageType );   
        
        // Pod Click Tracking: eVar160
        _psCommon.setPodClickMetrics( result, options.podClick );

        return result;
        
    },
    'bundle': ( item, options ) => {

        let result = {},
            bundleType = (typeof options.bundleType !== 'undefined' ? options.bundleType : '');
                        
        if ( bundleType == 'add' ) {

            utilities.setDimension( result, '_experience.analytics.event101to200.event171.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : '') );            
            utilities.setDimension( result, '_experience.analytics.event201to300.event222.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));

        } else if ( bundleType == 'remove' ) {
            
            utilities.setDimension( result, '_experience.analytics.event101to200.event172.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : '') );            
            utilities.setDimension( result, '_experience.analytics.event201to300.event223.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));
            
        }   
        
        return result;
    },
    'cancelSuccess': ( item, options ) => {

        let result = {};
    
        // Revenue events        
        utilities.setDimension( result, '_experience.analytics.event101to200.event147.value', digitalDataFormatters.stripComma( options.price.basePrice ) );  
        utilities.setDimension( result, '_experience.analytics.event101to200.event148.value', digitalDataFormatters.stripComma( item.quantity ) );

       // Fulfillment Method: eVar36
       _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

       return result;
                
    },
    'cartAdd': ( item, options ) => {

        // handle optional arguments
        options = (typeof options !== "undefined" ? options : {});
    
        let result = {},
            prodSku = ( options.sku && options.sku.toString().indexOf( "-pro" ) === -1 && options.prodInfo?.proReferralSelected ? `${options.sku}-pro` : options.sku ),     
            psAttributesIndex = -1,
            stashEtaObj = ( options.stashEta ? _psCommon.getETAObj( options.stashEta, options.sku ) : "" ),            
            stashRecommendation = _psCommon.getStashRecommendation( options.stashRecObj, options.sku );
                                        
        // Update SKU
        utilities.setDimension( result, 'SKU', prodSku );

        //event2,event4,event192
        _psCommon.setATCPriceAndQuantity( result, item, options.price );

        // Back Order Tracking non-check availability: event125
        _psCommon.setBackorderMetrics( result, options.prodInfo, options.fulfillment );

        //Handle RECOMMENDATIONS Metrics
        options.recommendation = _psCommon.getRecommendation( options.recommendation, stashRecommendation ); 
        

         // Parts and Services Attributes
         if ( Array.isArray( options.psAttributes ) && options.psAttributes.length ) {

            //match SKU to Anchor SKU
            psAttributesIndex = options.psAttributes.findIndex(obj => obj.anchorSku === prodSku);

            if ( psAttributesIndex !== -1 ) {
                
                // Hdpp Options (evar68)
                if ( typeof ( options.psAttributes[psAttributesIndex].hdppOption) !== 'undefined' ) {

                    //eVarArray.push('eVar68=hdpp:'+ options.psAttributes[psAttributesIndex].hdppOption);
                    utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar68', `hdpp:${options.psAttributes[psAttributesIndex].hdppOption}` ); 


                }

                // Install/Part/Haul Options (evar126)
                if ( typeof ( options.psAttributes[psAttributesIndex].installOption ) !== 'undefined' || typeof ( options.psAttributes[psAttributesIndex].partsOption ) !== 'undefined' || typeof ( options.psAttributes[psAttributesIndex].haulOption ) !== 'undefined' ) {
                    
                    //eVarArray.push('eVar126=install:' + (typeof options.psAttributes[psAttributesIndex].installOption !== 'undefined' ? options.psAttributes[psAttributesIndex].installOption : '') + '>haul:' + (typeof options.psAttributes[psAttributesIndex].haulOption !== 'undefined' ? options.psAttributes[psAttributesIndex].haulOption : ''));
                    utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar126', `install:${(typeof options.psAttributes[psAttributesIndex].installOption !== 'undefined' ? options.psAttributes[psAttributesIndex].installOption : '')}>parts:${(typeof options.psAttributes[psAttributesIndex].partsOption !== 'undefined' ? options.psAttributes[psAttributesIndex].partsOption : '')}>haul:${(typeof options.psAttributes[psAttributesIndex].haulOption !== 'undefined' ? options.psAttributes[psAttributesIndex].haulOption : '')}` ); 


                }
            } 
                                                    
        }


        // Consolidated the logic to conditionally set v64,v67,v102,v104 
        _psCommon.setRecommendationMetrics( result, options.recommendation );

        // BODF In-Store Assembly       
        if ( options.prodInfo?.assembly ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar18', options.prodInfo.assembly ); 

        }
        
        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );


        // ATC Location: eVar53
        _psCommon.setATCLocation( result, item.atcLocation, options.stashATCLoc, options.pageType  );

        // Check Fulfillment Availability: eVar7 (Only consider STASH value for cart add use case)
        _psCommon.setCheckFulfillmentAvailabilityMetrics( result, {}, "", options.stashCheckFulfillmentAvailability );    

        // ETA tracking ( Stash has the higher priority ): eVar112, eVar165, eVar166            
        _psCommon.setETAMetrics( result, stashEtaObj ? stashEtaObj : options.prodInfo );

        // Subscription Frequency Tracking: eVar115
        _psCommon.setSubscriptionMetrics( result, item);

        // Solver Path Tracking: eVar122
		_psCommon.setSolverPathMetrics( result, options.stashSolverPath, prodSku );
        
         // Pod Click Tracking: eVar160
        _psCommon.setPodClickMetrics( result, options.stashPodClick );
                
        // Badges Click-through tracking: eVar185
        if ( options.stashBadgeClickThrough ) {     

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar185', options.stashBadgeClickThrough ); 
            
        }

        // Bundle Type and PackageID Tracking: eVar48 and eVar202
        _psCommon.setBundleMetrics( result, options.prodInfo );

         // Gift Card Delivery Choice tracking: eVar206
        if ( item.giftCardDeliveryChoices ) {     

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar206', item.giftCardDeliveryChoices ); 
            
        }
                        
        // When we are adding a pro referral sku from cart or atc overlay, we append the parent sku to the product string.  This allows all the
        // events and evars to be attached to the proreferral sku. The item array check tells us that we are adding the pro referral item only (which
        // is when this condition is relevant)
        if ( options.prodInfo?.proReferralSelected && options.itemCount === 1) {

            options.productListItems[options.currentIndex + 1] = { 'SKU': options.sku };             

        }  
        
        return result;
                                            
    },    
    'cartCheckout': ( item, options ) => {
        
        let result = {},
            prodSku = ( options.sku && options.prodInfo?.proReferralSelected && options.sku.indexOf( "-pro" ) === -1 ? `${options.sku}-pro` : options.sku );

        //SKIP proReferal displayed items                    
        if ( options.prodInfo.proReferralDisplayed ) {
            delete result.SKU;
        } else {
            utilities.setDimension( result, 'SKU', prodSku );               
        } 

        return result;

    },
    'cartReAdd': ( item, options ) => {

        let result = {};
    
        // Revenue events                
        utilities.setDimension( result, '_experience.analytics.event101to200.event141.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event101to200.event142.value', digitalDataFormatters.stripComma( options.price.basePrice ) );  

        return result;

    },
    'cartRemove': ( item, options ) => {
        
        // handle optional arguments
        options = ( typeof( options ) !== "undefined" ? options : {} );

        let result = {};       
            
        // Handle SKUs for PRO-Referral Case
        if ( options?.prodInfo?.proReferralSelected ) {

            if ( options.sku.indexOf( "-pro" ) === -1 ) {

                utilities.setDimension( result, 'SKU', `${options.sku}-pro` );     

            }

            // When we are removing a pro referral sku, we append the parent sku to the product string.  This allows all the
            // events and evars to be attached to the proreferral sku            
            options.productListItems[options.currentIndex + 1] = { 'SKU': options.sku };             

        }       

        // Set product string events
        utilities.setDimension( result, '_experience.analytics.event1to100.event17.value', digitalDataFormatters.stripComma( item.quantity ) );            
        utilities.setDimension( result, '_experience.analytics.event1to100.event18.value', digitalDataFormatters.stripComma( options.price.basePrice ) );
        
        if ( options.v95 ) {
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar95', options.v95 );            
        }

        // Subscription Frequency Tracking: v115
        _psCommon.setSubscriptionMetrics( result, item);
        
        return result;
                
    },
    'cartView':  (item, options ) => {

        
        // handle optional arguments
        options = (typeof options !== "undefined" ? options : {});

        let result = {};
                
        // stashATCLoc is only set during shared cart scenario
        if ( options.stashATCLoc ) {

            //event2,event4,event192
            _psCommon.setATCPriceAndQuantity( result, item, options.price );
            
            // ATC Location: eVar53
            _psCommon.setATCLocation( result, item.atcLocation, options.stashATCLoc, options.pageType  );

        }
                
        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );
        
        // Fulfillment Store: eVar52
        _psCommon.setFulfillmentStoreMetrics( result, options.fulfillment );
            
        // ETA tracking: eVar112, eVar165, eVar166            
        _psCommon.setETAMetrics( result, options.prodInfo );

        // Subscription Frequency Tracking: eVar115
        _psCommon.setSubscriptionMetrics( result, item );  
                         
        // Cart Fulfillment Change variable: eVar121
        _psCommon.setCartFulfillmentChangeMetrics( result, options.fulfillment );
                                        
        // Back Order Tracking non-check availability: event125                    
        _psCommon.setBackorderMetrics( result, "", options.fulfillment );

        // Attached Labor (Installation/ProReferral/Sellable Assembly) Tracking: eVar131, event193
        _psCommon.setAttachedLaborMetrics( result, options.attachedLabor, options.prodInfo, { "method":"cartView", "sku": options.sku } );
        
         // Bundle Type and PackageID Tracking: eVar48 and eVar202
        if ( options.prodInfo && options.prodInfo.bundleType && options.prodInfo.packageID ) {
            _psCommon.setBundleMetrics( result, options.prodInfo );
        } else if ( item.bundleType || item.packageID ) {
            // If the bundleType or packageID is set on the item, we handle it here
            _psCommon.setBundleMetrics( result, { "bundleType": item.bundleType ?? "", "packageID": item.packageID ?? "" } );
        }

        // Revenue events
        if ( options.addRevenueEvents ) {
            
            utilities.setDimension( result, '_experience.analytics.event201to300.event260.value', 1);
            utilities.setDimension( result, '_experience.analytics.event201to300.event261.value', digitalDataFormatters.stripComma( item.quantity ) );
            utilities.setDimension( result, '_experience.analytics.event201to300.event262.value', digitalDataFormatters.stripComma( options.price.basePrice ) );  
            
            if ( typeof( options.price.giftCardPrice ) === 'undefined' ) { 					    

                
                utilities.setDimension( result, '_experience.analytics.event201to300.event262.value', digitalDataFormatters.stripComma( options.price.basePrice ) );                   

            } else  {                        
                
                utilities.setDimension( result, '_experience.analytics.event1to100.event28.value', digitalDataFormatters.stripComma( options.price.giftCardPrice ) ); 
                
            }
            
        }
                    
        // For pro referral/installation sku, we only want to append the events and evars assocaited to installation (event193 and v131)
        if ( options.sku.indexOf( "-pro" ) === -1 && ( options.prodInfo.proReferralSelected || options.prodInfo.proReferralDisplayed || options.prodInfo.installationDisplayed ) ) {                        

            // Update SKU
            utilities.setDimension( result, 'SKU', `${options.sku}-pro` );
            
        } 
        
        // Private label is treated as separate SKU built from the image array fields.  We append it to the end of the product string
        if ( options.isLastItem && options.content && Array.isArray(options.content.image) && options.content.image[0] && options.content.image[0].type && options.content.image[0].name ) {
    
            options.productListItems[options.currentIndex + 1] = { 'SKU':  `image>${options.content.image[0].type}>${options.content.image[0].name}` };   
        }

		// Badges tracking
		if ( Array.isArray( options.prodInfo.badge ) && options.prodInfo.badge.length ) {
			utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar49', _psCommon.setBadgeData( options.prodInfo.badge ) );
		}

        // Ship From Fastest Location (Fulfillment Change) Tracking: event308       
        _psCommon.setShipFromFastestLocationMetrics( result, options.prodInfo );
        
        return result;
        
    },
    'checkFulfillment': ( item, options ) => {
        
        let result = {};

        // Check Fulfillment Availability: eVar7
        _psCommon.setCheckFulfillmentAvailabilityMetrics( result, options.fulfillment, options.pageType );    

         // ETA tracking: eVar112, eVar165, eVar166                     
        _psCommon.setETAMetrics( result, options.prodInfo );      
    
        // Back Order Tracking non-check availability: event125
        _psCommon.setBackorderMetrics( result, options.prodInfo );

        return result;

    },
    'confirmReturn': ( item, options ) => {

        let result = {};
                   
        // Set product string events             
        utilities.setDimension( result, '_experience.analytics.event101to200.event146.value', 1);
        utilities.setDimension( result, '_experience.analytics.event101to200.event147.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event101to200.event148.value', digitalDataFormatters.stripComma( options.price.basePrice ) );

        if ( item.returnMethod ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar4', item.returnMethod );   

        }
        
        return result;

    },
    'couponApplicationChange': ( item, options ) => {

        let result = {};

        // Discount Code Tracking: eVar20, event57
        _psCommon.setDiscountMetrics( result, options.price );

        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

        // Fulfillment Store: eVar52
        _psCommon.setFulfillmentStoreMetrics( result, options.fulfillment );

        return result;
                    
    },
    'discoveryZone': ( item, options ) => {

        let result = {},
            _formatDiscoveryZone = ( zoneObj ) => {
    
                const _clean = ( str) => {
    
                    if ( typeof str === "string" ) {
                        str = str.replace( /:/g, "-" );
                    }
            
                    return str;
                }
    
                let result = [];
    
                result.push(zoneObj.zoneName ? _clean( zoneObj.zoneName ) : '');            
                result.push(zoneObj.zonePosition ? _clean( zoneObj.zonePosition ) : '');            
                result.push(zoneObj.pageType ? _clean( zoneObj.pageType ) : '');                    
                result.push(zoneObj.displayPosition ? _clean( zoneObj.displayPosition ) : '');                
                result.push(zoneObj.podResults ? _clean( zoneObj.podResults ) : '');
                result.push(zoneObj.strategy ? _clean( zoneObj.strategy ) : 'n/a');
    
                return result.join(":");                        
            },
            zone = ( options.zone ? options.zone : "" );
             
        // discovery zone click tracking
        if ( zone ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar109', _formatDiscoveryZone( zone ) );  

        }
            
        return result;

    },
    'giftCard': ( item, options ) => {
        
        let result = {}; 
        
        utilities.setDimension( result, '_experience.analytics.event101to200.event144.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));
        utilities.setDimension( result, '_experience.analytics.event101to200.event145.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));

        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

        return result;
                            
    },
    'giftCardRemove': ( item, options ) => {

        let result = {},    
            v23 = ( options.v23 ? options.v23 : "" );
            
        // Set product string events                     
        utilities.setDimension( result, '_experience.analytics.event1to100.event29.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event1to100.event35.value', digitalDataFormatters.stripComma( options.price.basePrice ) );

        if ( v23 ) {
            
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar23', v23 );   

        }

        return result;

    },
    'installationSku': ( item, options ) => {
        
        let result = {},
            nextItem = {}, 
            v131 = "";
        
        // Attached Labor (Installation/ProReferral/Sellable Assembly) Tracking: eVar131, event193
        v131 = _psCommon.setAttachedLaborMetrics( result, options.attachedLabor, options.prodInfo, { "method":"installationSku", "index": options.currentIndex } );
        
        //set anchor SKU and associated metrics as a new item on the product string
        if ( v131 && options.prodInfo.anchorSku ) {

            nextItem.SKU = String( options.prodInfo.anchorSku );

            utilities.setDimension( nextItem, '_experience.analytics.event101to200.event193.value', 1 );
            utilities.setDimension( nextItem, '_experience.analytics.customDimensions.eVars.eVar131', v131 );
            
            options.productListItems[options.currentIndex + 1] = nextItem;   

        }

        return result;

    },   
    'myListCreate': ( item, options ) => {
        
        let result = {}; 

        // Set product string events
        utilities.setDimension( result, '_experience.analytics.event1to100.event52.value', 1 );                    
        utilities.setDimension( result, '_experience.analytics.event101to200.event101.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));

        // List Location Tracking: eVar81
        _psCommon.setListLocationMetrics( result, item );

        return result;
        
    },        
    'myListAddRemove': ( item, options ) => {
        
        let result = {},
            type = (typeof options.type === 'string' ? options.type.toLowerCase() : '');
    
       if ( type === 'add' ) {

            utilities.setDimension( result, '_experience.analytics.event1to100.event100.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));

       } else if ( type === 'remove') {

            utilities.setDimension( result, '_experience.analytics.event101to200.event102.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));

       }  
       
       return result;
    },
    'opc': ( item, options ) => {
        
        let result = {};

        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

        // ETA tracking: eVar112, eVar165, eVar166                     
        _psCommon.setETAMetrics( result, options.prodInfo );

        // Subscription Frequency Tracking: eVar115
        _psCommon.setSubscriptionMetrics( result, item );  

        // Service Level Tracking: eVar189
       _psCommon.setServiceLevelMetrics( result, options.prodInfo );

       return result;
                           
    },
    'optimalFulfillmentChange': ( item, options ) => {
        
        let result = {};

        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

        // Cart Fulfillment Change variable: eVar121
        _psCommon.setCartFulfillmentChangeMetrics( result, options.fulfillment );

        return result;
        
    },  
    'projectAdd': ( item, options ) => {
                
        let result = {};
                                                
        // Set product string events
        utilities.setDimension( result, '_experience.analytics.event201to300.event299.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event201to300.event300.value', digitalDataFormatters.stripComma( options.price.basePrice ) );
        
           
        if ( options.projectId ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar196', options.projectId ); 

        }
        
        if ( item.projectLocation ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar197', item.projectLocation ); 

        }

        return result;
    },  
    'productView': ( item, options ) => {
        
        // handle optional arguments
        options = ( typeof( options ) !== "undefined" ? options : {} );

        let result = {},              

            prodSku = ( options.sku && options.sku.indexOf( "-pro" ) === -1 && options.prodInfo?.laborType === "proreferral" ? `${options.sku}-pro` : options.sku ),            
                        
            productStatus = ( options.prodInfo && options.prodInfo.availabilityStatus ? options.prodInfo.availabilityStatus : '' ),

            shippingStatus = ( productStatus.shipping ? productStatus.shipping : '' ),

            storeStatus = ( productStatus.store ? productStatus.store : '' ),
            
            stashRecommendation = _psCommon.getStashRecommendation( options.stashRecObj, options.sku ),

            v131 = "";
        
        // Update SKU
        utilities.setDimension( result, 'SKU', prodSku );  

        //Handle RECOMMENDATIONS Metrics
        options.recommendation = _psCommon.getRecommendation( options.recommendation, stashRecommendation ); 

        // Consolidated the logic to conditionally set v64,v67,v102,v104 
        _psCommon.setRecommendationMetrics( result, options.recommendation, options.recNewTab );
                
         // ETA tracking: eVar112, eVar165, eVar166                     
        _psCommon.setETAMetrics( result, options.prodInfo );

        // BODFS Delivery message on PIP: evar113
        if ( options.prodInfo?.bodfsDeliveryFee ) {
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar113', options.prodInfo.bodfsDeliveryFee ); 
        }
        
        // Badges tracking
        if ( Array.isArray( options.prodInfo.badge ) && options.prodInfo.badge.length ) {                
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar114', _psCommon.setBadgeData( options.prodInfo.badge ) );   
        }

        // Solver Path Tracking: eVar122
        _psCommon.setSolverPathMetrics( result, options.stashSolverPath );

        // eta deta tracking
        if ( utilities.objHasValue( options.prodInfo.eta ) && typeof( options.prodInfo.eta.deta ) !== 'undefined' ) {                
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar127', ( options.prodInfo.eta.deta ? 'deta:y' : 'deta:n' ) ); 
        }

        // Badges Click-through tracking
        if ( options.stashBadgeClickThrough ) {                
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar185', options.stashBadgeClickThrough ); 
        }

        // Collections Product Click tracking
        if ( options.collectionsProductClick ) {                
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar201', options.collectionsProductClick ); 
        }
    
        // Back Order Tracking non-check availability: event125
        _psCommon.setBackorderMetrics( result, options.prodInfo );
		
        // Clearance Messaging: Limited Stock on PIP
        if ( options.prodInfo.availabilityStatus && typeof ( options.prodInfo.availabilityStatus.isLimitedQuantity ) !== 'undefined' ) {
					
            if ( options.prodInfo.availabilityStatus.isLimitedQuantity === true ) {
                utilities.setDimension( result, '_experience.analytics.event1to100.event63.value', 1 );
            }

        }
		
        // Attached Labor (Installation/ProReferral/Sellable Assembly) Tracking: eVar131, event193
        v131 = _psCommon.setAttachedLaborMetrics( result, options.attachedLabor, options.prodInfo, { "method":"productView", "index": options.currentIndex } );
                
         //set anchor SKU and associated metrics as a new item on the product string
         if ( v131 ) {
 
             utilities.setDimension( result, '_experience.analytics.event101to200.event193.value', 1 );
             utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar131', v131 );
             
         }
                    
        //OOS Tracking: event56,event195,event198,event204,event205,event206,event207
        _psCommon.setOOSMetrics( result, shippingStatus, storeStatus );

        //In-Store Assembly Eligibility: event271
        _psCommon.setInstoreAssemblyMetrics( result, options.prodInfo );
        
        // PIP OOS  Product Available Type Tracking: eVar133
        _psCommon.setProductAvailabilityTypeMetrics( result, options.prodInfo );

        //Store Type/Multi Store analytics: eVar134
        _psCommon.setStoreTypeMetrics( result, options.prodInfo );
        
        // Badge Type Tracking: eVar149
        _psCommon.setBadgeTypeMetrics( result, options.badges );

        // Pod Click Tracking: eVar160
        _psCommon.setPodClickMetrics( result, options.stashPodClick );

        // IDM Feed - For every product: eVar187
        _psCommon.setIDMMetrics( result, options.prodInfo );
        
        // Ship From Fastest Location (Fulfillment Change) Tracking: event308       
        _psCommon.setShipFromFastestLocationMetrics( result, options.prodInfo );

        // Bundle Type and PackageID Tracking: eVar48 and eVar202
        _psCommon.setBundleMetrics( result, options.prodInfo );

        // MAP Pricing Displayed (Auth/Unauth): eVar209
        _psCommon.setMapPricingMetrics( result, options.prodInfo );
        
        return result;
                
    },
    'productImpression': ( item, options ) => {

        // handle optional arguments
        options = (typeof options !== "undefined" ? options : {});

        let result = {},

            podObject = {},        
            
            productStatus = ( options.prodInfo && options.prodInfo.availabilityStatus ? options.prodInfo.availabilityStatus : '' ),

            shippingStatus = ( productStatus.shipping ? productStatus.shipping : '' ),

            storeStatus = ( productStatus.store ? productStatus.store : '' );      

    
        // Consolidated the logic to conditionally set v64,v67,v102,v104 
        _psCommon.setRecommendationMetrics( result, options.recommendation );
        
        //Store Type/Multi Store analytics: eVar134
        _psCommon.setStoreTypeMetrics( result, options.prodInfo );
    
        // PLP OOS Product Available Type Tracking: eVar133
        _psCommon.setProductAvailabilityTypeMetrics( result, options.prodInfo );
        
        // Badge Type Tracking: eVar149
        _psCommon.setBadgeTypeMetrics( result, options.prodInfo?.badge );

        // Badge Clickthrough Tracking: eVar185
        if ( Array.isArray( options.prodInfo.badge ) && options.prodInfo.badge.length ) {                
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar185', _psCommon.setBadgeData( options.prodInfo.badge, options.pageType, "name" ) );
        }

        // Pod Click Tracking: eVar160
        if ( options.pageNumber ) {

            podObject = { 
                "sponsoredProduct": ( typeof ( options?.prodInfo?.sponsored ) !== 'undefined' ? options.prodInfo.sponsored : '' ),
                "podPageNumber": options.pageNumber,
                "podPosition": ( options.currentIndex * 1 + 1 )
            };
            
            _psCommon.setPodClickMetrics( result, podObject, '' );
        }

        //OOS Tracking: event56,event195,event198,event204,event205,event206,event207
        _psCommon.setOOSMetrics( result, shippingStatus, storeStatus );  
                      
        // MAP Pricing Displayed (Auth/Unauth): eVar209
        _psCommon.setMapPricingMetrics( result, options.prodInfo );

        return result;
    },
    'productPod': ( item, options ) => {

        let result = {};

        // Pod Click Tracking: eVar160
        _psCommon.setPodClickMetrics( result, options.podClick );

        return result;
        
    },     
    'proreferralSku': ( item, options ) => {

        let result = {},       
            v131 = "";    
                        
        // Attached Labor (Installation/ProReferral/Sellable Assembly) Tracking: eVar131, event193
        v131 = _psCommon.setAttachedLaborMetrics( result, options.attachedLabor, options.prodInfo, { "method":"proreferralSku" } );
        
        //set anchor SKU and associated metrics as a new item on the product string
        if ( v131 || options?.attachedLabor.proreferralFound ) {
            
            utilities.setDimension( result, '_experience.analytics.event101to200.event193.value', 1 );
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar131', v131 );
                        
        }

        return result;
    
    },
    'projectRemove': ( item, options ) => {
                
        let result = {};
                                                
        // Set product string events
        utilities.setDimension( result, '_experience.analytics.event301to400.event303.value', digitalDataFormatters.stripComma( item.quantity ) );
        utilities.setDimension( result, '_experience.analytics.event301to400.event304.value', digitalDataFormatters.stripComma( options.price.basePrice ) );
        
           
        if ( options.projectId ) {

            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar196', options.projectId ); 

        }
        
        return result;
    },
    'psOverlay': ( item ) => {
        
        let result = {},
            ps = ( item.psOverlay ? item.psOverlay : {} ),
            v126 = "install:" + (typeof ps.installOption !== 'undefined' ? ps.installOption : '') +
            ">parts:" + (typeof ps.partsOption !== 'undefined' ? ps.partsOption : '') +
            ">haul:" + (typeof ps.haulOption !== 'undefined' ? ps.haulOption : '') +
            ">hdpp:" + (typeof ps.hdppOption !== 'undefined' ? ps.hdppOption : '');
            
        // Update SKU
        utilities.setDimension( result, 'SKU', (item.anchorSku ? item.anchorSku : '') ); 

        // Parts and services overlay: eVar126
        utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar126', v126 );

        return result;

    },    
    'purchase': ( item, options ) => {
        
        let result = {};
        
        // Update SKU For pro referral
        if ( options.sku.indexOf( "-pro" ) === -1 && options.prodInfo.proReferralSelected ) {                        
            
            utilities.setDimension( result, 'SKU', `${options.sku}-pro` );
            
        } 

        // Price and Quantity        
        utilities.setDimension( result, 'quantity', digitalDataFormatters.stripComma(item.quantity) );
        utilities.setDimension( result, 'priceTotal', digitalDataFormatters.stripComma(options.price.basePrice) );
                
        //SKU Counter
        utilities.setDimension( result, '_experience.analytics.event201to300.event228.value', 1 );

        // Back Order Tracking non-check availability: event125                    
        _psCommon.setBackorderMetrics( result, "", options.fulfillment );
        
        //In-Store Assembly Eligibility: event271
        _psCommon.setInstoreAssemblyMetrics( result, options.prodInfo );
 
        // Fulfillment Method: eVar36
        _psCommon.setFulfillmentMethodMetrics( result, options.fulfillment );

        // Fulfillment Store: eVar52
        _psCommon.setFulfillmentStoreMetrics( result, options.fulfillment );

        // Fulfillment Service Level: eVar57
        if ( options.fulfillment.serviceLevel ) {
        
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar57', options.fulfillment.serviceLevel );

        }

        // Fulfillment Delivery Window: eVar58
        if ( options.fulfillment.deliveryWindow ) {
           
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar58', options.fulfillment.deliveryWindow );

        }

        // Fulfillment Pickup Option: eVar182
        if ( options.fulfillment.pickupOption ) {
           
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar182', options.fulfillment.pickupOption );

        }
        
        // Gift Card Revenue: event41
        if ( typeof( options.price.giftCardPrice ) !== 'undefined' ) {
            
            utilities.setDimension( result, '_experience.analytics.event1to100.event41.value', digitalDataFormatters.stripComma(options.price.giftCardPrice) );

        }

        // Gift Card Reload Revenue: event61
        if ( typeof( options.price.giftCardReloadPrice ) !== 'undefined' ) {
            
            utilities.setDimension( result, '_experience.analytics.event1to100.event61.value', digitalDataFormatters.stripComma(options.price.giftCardReloadPrice) );

        }

        // Discount Code Tracking: eVar20, event57
        _psCommon.setDiscountMetrics( result, options.price );

        // Subscription Frequency Tracking: eVar115
        _psCommon.setSubscriptionMetrics( result, item );  

        // IDM Feed - For every product: eVar187
        _psCommon.setIDMMetrics( result, options.prodInfo );
        
        // Service Level Tracking: eVar189
        _psCommon.setServiceLevelMetrics( result, options.prodInfo );

        return result;
                         
    },
    'quoteAdd': ( item, options ) => {

        let result = {},
            quoteId = (options.quoteid ? options.quoteid : ""),
            quoteLocation = (item.quoteLocation ? item.quoteLocation : ""),
            quoteType = (options.quotetype ? options.quotetype : ""); 
    
        utilities.setDimension( result, '_experience.analytics.event101to200.event187.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));
        utilities.setDimension( result, '_experience.analytics.event101to200.event188.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));
        utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar205', item.productException ? item.productException : "" );

        _psCommon.setQuoteMetrics( result, quoteId, quoteType, quoteLocation );    

        return result;
                   
    },    
    'quoteRemove': ( item, options ) => {
        
        let result = {},
            quoteId = (options.quoteid ? options.quoteid : ""),            
            quoteType = (options.quotetype ? options.quotetype : ""); 
    
        utilities.setDimension( result, '_experience.analytics.event101to200.event151.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));
        utilities.setDimension( result, '_experience.analytics.event101to200.event150.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));

        _psCommon.setQuoteMetrics( result, quoteId, quoteType, "" );                                   
       
        return result;

    },
    'saveForLater': ( item, options ) => {
        
        let result = {}; 
        
        utilities.setDimension( result, '_experience.analytics.event101to200.event138.value', ( item.quantity ? digitalDataFormatters.stripComma(item.quantity) : ''));
        utilities.setDimension( result, '_experience.analytics.event101to200.event139.value', ( options.price.basePrice ? digitalDataFormatters.stripComma(options.price.basePrice) : ''));

        return result;
                                
    },
    'selfServiceReturn': ( item ) => {

        let result = {}; 
                        
        if ( typeof( item.qty ) !== "undefined" ) {

            utilities.setDimension( result, '_experience.analytics.event1to100.event79.value', digitalDataFormatters.stripComma( item.qty ) );

        }

        if ( typeof( item.returnReason ) !== "undefined" ) {
            
            // Self Service Return Reason: eVar79
            utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar79', item.returnReason );

        }

        return result;
    },
    'skuOnly': ( ) => {

        //Place holder for future use. Sku set by default in run method

        let result = {}; 
        
        return result;
                                
    },   
    'ugcClick': ( item, options ) => {

        let result = {},
            ugcResult = ( function ( ugcArr ) {
			let result = "",
				ugc = ( Array.isArray( ugcArr ) && ugcArr[ ugcArr.length - 1 ] ? ugcArr[ ugcArr.length - 1 ] : "" );

			if ( ugc ) {
				result += ( ugc.module ? ugc.module : "n/a" ) + ">";
				result += ( ugc.component ? ugc.component : "n/a" ) + ">";
				result += ( ugc.element ? ugc.element : "n/a" );
			}

			return result;

		}( options.ugcObj ) );

        utilities.setDimension( result, '_experience.analytics.customDimensions.eVars.eVar128', ugcResult );
        
        return result;
    }
};

const run = ( method = '', itemArray, params = {} ) => {

    //Exit early if we dont have a valid item array
    if ( !Array.isArray( itemArray ) ) return []; 
    if ( !itemArray.length ) return [];

    let productListItems = [],      
        currentItem,
        lastIndex = itemArray.length - 1;
    
    //set use case specific function globals.  These are variables we want to set OUTSIDE the main loop.  
    //[TODO]: investigate pre-formatting these here rather than inside the loop, since all items in the loop will have the same value      
    
    params.itemCount = itemArray.length;
    
    if ( ['attachedLaborSku','installationSku','proreferralSku'].includes(method) ) {

        params.attachedLabor = _psCommon.getAttachedLabor( itemArray );
        params.laborType = ( params.laborType ? params.laborType : "");
      
    } else if ( method === 'bssOverlay' ) {

        params.pageType = ( params.pageType ? params.pageType : "");
        params.podClick = ( params.podClick ? params.podClick : "" );
        
      
    } else if ( method === 'cartAdd' ) {

        params.pageType = ( params.pageType ? params.pageType : "");
        params.psAttributes = ( params.psAttributes ? params.psAttributes : []);
        params.stashATCLoc = ( params.atcloc ? params.atcloc : "" );
        params.stashBadgeClickThrough = ( params.badgeClickThrough ? params.badgeClickThrough : "" ),
        params.stashCheckFulfillmentAvailability = ( params.checkfulfillobj ? params.checkfulfillobj : "" );
        params.stashEta = ( params.stashEta  ? params.stashEta : "" ); 
        params.stashPodClick = ( params.podclick ? params.podclick : "" ),
        params.stashRecObj = ( params.recobj ? params.recobj : "" );        
        params.stashSolverPath = ( params.solverpath ? params.solverpath : "" );

      
    } else if ( method === 'cartView' ) {

        params.addRevenueEvents = ( params.addrevenueevents ?  params.addrevenueevents : "" );
        params.attachedLabor = _psCommon.getAttachedLabor( itemArray );
        params.content =  ( params.content ? params.content : "");
        params.pageType = ( params.pageType ? params.pageType : "");
        params.stashATCLoc = ( params.atcloc ? params.atcloc : "" );
        
    } else if ( method === 'productView' ) {
        
        params.attachedLabor = _psCommon.getAttachedLabor( itemArray );
        params.stashBadgeClickThrough = ( params.badgeClickThrough ? params.badgeClickThrough : "" ),        
        params.stashPodClick = ( params.podclick ? params.podclick : "" ),
        params.stashRecObj = ( params.recobj ? params.recobj : "" ),       
        params.stashSolverPath = ( params.solverpath ? params.solverpath : "" ),        
        params.badges = ( params.badges ? params.badges : [] );
        params.collectionsProductClick = ( params.collectionsProductClick ? params.collectionsProductClick : "" );
        params.recNewTab = (params.recNewTab ? params.recNewTab : "");

    } else if ( method === 'productImpression' ) {

        params.pageNumber = ( params.pageNumber ? params.pageNumber : "");
        params.pageType = ( params.pageType ? params.pageType : "");

    }


    // Main LOOP 
    itemArray.forEach( ( item, index ) => {

        currentItem = {};
        
        // add shared data to params to be used in downstream methods        
        params.currentIndex = productListItems.length;
        params.fulfillment = _psCommon.normalizeFulfillment( item );
        params.isLastItem = lastIndex === index;
        params.price = _psCommon.normalizePrice( item );
        params.prodInfo = item.productInfo ? item.productInfo : item;
        params.prodInfoOption = params.prodInfo?.option ? params.prodInfo.option : {};               
        params.productListItems = productListItems;
        params.recommendation = _psCommon.normalizeRecommendation( item );
        params.sku = _psCommon.getSKUFromProdInfo( params.prodInfo );

        currentItem.SKU = String( params.sku );

        // Dynamically execute any use-case specific methods
        if ( typeof( method ) !== 'undefined' && typeof( _psMethods[method] ) === 'function' ) {
				
           currentItem = { ...currentItem, ..._psMethods[method]( item, params ) };

        }

        /* Guard against adding empty items. Some use cases, such as cartCheckout with a proreferral a displayed, do not result in a PS being set. */
        if ( utilities.objHasValue( currentItem ) ) {

            productListItems[params.currentIndex] = currentItem;

        }

    });

    return productListItems;

};

export {
    run
};
